// extracted by mini-css-extract-plugin
export default {"input":"DayInput_input__zVGYX"};